import React from 'react'
import { Link } from 'react-router-dom';
import { useViewport } from '../../../utils';
import { useSelector } from 'react-redux';

const label = {
  en: 'See Details',
  id: 'Lihat Detailnya'
}

const ListItem = ({data, index}) => {
  const backgroundColor = index % 2 === 1 ? '#fff' : '#f9f9f9';
  const { isMobile } = useViewport()
  const size = isMobile ? '73px' : '90px'/* '80px' */
  const { language } = useSelector(state => state.system)

  const {
    title,
    note,
    image,
    date,
    date_by_language = {},
    organization,
    event_id,
    reschedule_note
  } = data

  const titleRendered = typeof title === 'string' ? title : title && title[language.name] ? title[language.name] : JSON.stringify(title)

  return (
    <div
      className="w-full px-5 py-4 lg:py-5 relative"
      style={{background: backgroundColor}}
    >
      <div className="flex mb-4">
        {
          image ? (
            <div
              style={{minWidth: size, height: size, backgroundImage: `url('${image}')`}}
              className="rounded mr-4 lg:mr-5 bg-cover bg-no-repeat bg-center"
            />
          ) : (
            <div
              style={{minWidth: size, height: size, backgroundColor: '#ddd'}}
              className="rounded mr-4 lg:mr-5"
            />
          )
        }
        <div>
          <div className="w-3/4">
            <h1 className="font-primary font-bold mb-2">{titleRendered}</h1>
            <div className="text-xs leading-tight text-gray-999 mb-3 lg:mb-0">
              <p>{date_by_language[language.name] ? date_by_language[language.name] : date}</p>
              {
                note &&
                <p>{note}</p>
              }
              <p className="mt-1 lg:mt-2">{organization}</p>
            </div>
          </div>
          <div className="link lg:absolute top-0 right-0 lg:p-5">
            <Link className="text-xs lg:text-sm" to={`/dashboard/tickets/detail/${event_id}`}>
              {label[language.name]}
            </Link>
          </div>
        </div>
      </div>
      {
        (reschedule_note && reschedule_note !== null) &&
        <p className="text-sm p-4 bg-toast-warning text-toast-warning-text rounded">
          {reschedule_note}
        </p>
      }
    </div>
  )
}

export default ListItem
